// ----------------------------------------------------------------------
// <copyright file="Izenda.MiddlePanel.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------


/**
 * MiddlePanel component
 */
!(function () {
  var ReactDOM = require('react-dom');
  var React = require('react');
  var classnames = require('classnames');
  var LayoutUtils = require('share/utils/Izenda.LayoutUtils');
  var BrowserUtils = require('share/utils/Izenda.BrowserUtils');
  var Divider = require('share/components/controls/Izenda.Divider');
  
  var DEFAULT_MIDDLE_PANEL_WIDTH = 250;
  var DEFAULT_SIDEBAR_WIDTH = 250;
  
  var MiddlePanel = React.createClass({

    displayName: 'MiddlePanel',
    /**
     * Get default properties
     */
    getDefaultProps: function () {
      return {
        disabled: false,
        hidden: false
      };
    },

    hideSidebar: function() {
      LayoutUtils.toggleMiddelPanel(false, true);
    },

    getMaxContainerWidth: function() {
      var screenWidth = BrowserUtils.getScreenSize().width;
      // calculate with padding left sidebar
      return screenWidth / 2 - DEFAULT_SIDEBAR_WIDTH - 10;
    },

    render: function () {
      var config = {
        defaultValue: DEFAULT_MIDDLE_PANEL_WIDTH,
        minValue: 0,
        maxValue: this.getMaxContainerWidth()
      };

      var classes = classnames({
        "izenda-MiddlePanel": true,
        "disabled-elm": this.props.disabled,
      });

      return this.props.hidden
        ? null
        : (
          <div className={classes} aria-expanded="false">
            <div className="izenda-Wrapper">
              <div className="izenda-MiddlePanel-icon">
                <div className="izenda-NavIcon expanded" onClick={this.hideSidebar}>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
              
              {this.props.children}

              <Divider config={config} orientation="horizontal" nodeHandle="parentNode.parentNode" />
            </div>
          </div>
        )
    }
  });

  module.exports = MiddlePanel;
}());



// WEBPACK FOOTER //
// ./ui/share/components/layout/Izenda.MiddlePanel.jsx